export const STUDY_ITEMS = {
  vod: "동영상",
  zoom: "Live강의",
  assignment: "과제",
  quiz: "퀴즈",
  choiceanswer: "간편설문",
  feedback: "설문조사",
  peerreview: "과제상호평가",
  url: "url",
  courseboard: "게시판",
  content: "파일",
  vpl: "코딩교육",
  folder: "폴더",
};
export const STUDY_ITEMS_SORT = {
  "동영상": 1,
  "Live강의": 2,
  "과제": 3,
  "퀴즈": 4,
  "간편설문": 5,
  "설문조사": 6,
  "과제상호평가": 7,
  "url": 8,
  "게시판": 9,
  "파일": 10,
  "코딩교육": 11,
  "폴더": 12,

}
export const SEMESTERS = {
  10: "봄", 11: "여름", 20: "가을", 21: "겨울"
};
